<template>
  <search-group @search="findData" @clear="clearValue" :span="24" :btnSpan="6" :inline="true" :btnOffset="21">
    <Row class="mb16" :gutter="16">
      <Col span="4">
        <Input v-model="searchData.labelName" type="text" placeholder="标签名称"></Input>
      </Col>
      <Col span="4">
        <Select v-model="searchData.labelSecondaryType" placeholder="标签类型">
          <Option value>请选择</Option>
           <Option
            v-for="({value,text},index) in yyLabelList"
            :key="'prj'+index"
            :value="value"
          >{{text}}</Option>
          <!-- <Option v-for="({text,value},index) in yyList" :key="'aud'+index" :value="value">{{text}}</Option> -->
        </Select>
      </Col>
    </Row>
  </search-group>
</template>

<script>
import SearchGroup from "components/SearchGroup/index";
import {getYYConditionList} from "../../../../api/labelmanage";
export default {
  components: {
    SearchGroup
  },
  data() {
    return {
      yyLabelList:[],
      //查询数据参数
      searchData: {
        labelName:'',
        labelSecondaryType:'',
      }
    };
  },
  created(){
    this.getConditionList();
  },
  methods: {
    findData() {
     this.$emit('search',this.searchData)
    },
    clearValue() {
      this.searchData = {
        labelName:'',
        labelSecondaryType:'',
      };
    },
    getConditionList(){
      getYYConditionList().then(res=>{
        this.yyLabelList = res.data.secondaryYYType;
      })
    },
  }
};
</script>

<style>
</style>